import { z } from 'zod';
import { paginationQueryResponse } from './pagination';

export const contentsInProgressSchema = z.object({
  data: z.array(
    z.object({
      documentId: z.nullable(z.string()),
      title: z.nullable(z.string()),
      progress: z.nullable(z.number()),
      lessons: z.array(
        z.object({
          duration: z.nullable(z.number()),
          lessonProgresses: z.array(
            z.object({
              progress_status: z.nullable(z.string()),
              current_second: z.nullable(z.number()),
            }),
          ),
        }),
      ),
      thumbnail: z.nullable(z.object({ url: z.nullable(z.string()) })),
    }),
  ),
  pagination: paginationQueryResponse,
});

export type ContentsInProgress = z.infer<typeof contentsInProgressSchema>;
